import PopupMenu from "./popup-menu";
import PopupMenuItem from "./popup-menu-item";
PopupMenu.Item = PopupMenuItem;
export default PopupMenu;
//# sourceMappingURL=index.js.map